import { render, staticRenderFns } from "./v-navigation-card.vue?vue&type=template&id=1857c56c&scoped=true&"
import script from "./v-navigation-card.vue?vue&type=script&lang=js&"
export * from "./v-navigation-card.vue?vue&type=script&lang=js&"
import style0 from "./v-navigation-card.vue?vue&type=style&index=0&id=1857c56c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1857c56c",
  null
  
)

export default component.exports